import classNames from 'classnames'
import React, { useEffect, useMemo } from 'react'

import { useHybridFocusable } from '../../hooks/useHybridFocusable'
import tts from '../../lib/TTS'

import type { FocusableCardProps } from './types'

function FocusableCard<T>({
  onEnterPress,
  onFocus,
  layout,
  index,
  ttsText = '',
  className = '',
  children,
  onArrowPress,
  focusKey,
}: FocusableCardProps<T>) {
  const { ref, focused, isHovered } = useHybridFocusable({
    onEnterPress: (...args) => {
      tts.stopRead()
      onEnterPress?.(...args)
    },
    onFocus,
    onArrowPress,
    focusKey,
    extraProps: { index },
  })

  useEffect(() => {
    if (focused && ttsText) {
      tts.stopRead()
      tts.addTextToRead(ttsText)
    }
  }, [focused, ttsText])

  const style = useMemo(
    () =>
      ({
        height: `${layout.cardHeight}px`,
        width: `${layout.cardWidth}px`,
        minWidth: `${layout.cardWidth}px`,
        marginRight: `${layout.cardMarginRight}px`,
      } as React.CSSProperties),
    [layout]
  )

  return (
    <div
      ref={ref}
      style={style}
      className={classNames('focusable-card', {
        [className]: !!className,
        'focusable-card--focused': focused,
        'focusable-card--hovered': isHovered,
      })}
    >
      {children}
    </div>
  )
}

export default FocusableCard
